module.exports = __webpack_public_path__ + "static/media/cupra.f7d945ee.png";